import { OidcProviderProps } from '@changegps/access-identity';

export const oidcConfig: OidcProviderProps = {
  environment: ENV.ENVIRONMENT,
  authServiceUrl: ENV.AUTH_SERVICE_URL,
  baseUrl: ENV.BASE_URL,
  oidcEnvironment: ENV.OIDC_ENVIRONMENT,
  oidcDomain: ENV.OIDC_DOMAIN,
  oidcClientId: ENV.OIDC_CLIENT_ID,
  oidcClientSecret: ENV.OIDC_CLIENT_SECRET,
  oidcRedirectUri: ENV.OIDC_REDIRECT_URI,
  oidcSilentRedirectUri: ENV.OIDC_SILENT_REDIRECT_URI,
  oidcPostLogoutUri: ENV.OIDC_POST_LOGOUT_URI,
  oidcScope: ENV.OIDC_SCOPE,
  disablePKCE: ENV.DISABLEPKCE,
};
